import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import {
  consumeGoogleAuthCallbackUrl,
  consumePendingBillingCheckoutIntent,
  exchangeBetterAuthSessionGrant,
  readPendingBillingCheckoutIntent,
  startCheckout,
  writeStoredSaleskoSession
} from "../../../lib/api";

export const Route = createFileRoute("/auth/google/callback")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "Salesko Sign In" },
      { name: "robots", content: "noindex, nofollow" }
    ]
  }),
  component: GoogleAuthCallbackRoute
});

function GoogleAuthCallbackRoute() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;

    async function consumeCallback() {
      const result = consumeGoogleAuthCallbackUrl(window.location.href);
      if (result?.status === "error") {
        if (active) {
          setError(result.error);
        }
        return;
      }

      try {
        const session = result?.status === "success" ? result.session : await exchangeBetterAuthSessionGrant();
        if (!active) {
          return;
        }

        writeStoredSaleskoSession(session);
        window.history.replaceState(null, "", "/auth/google/callback");
        const pendingCheckout = readPendingBillingCheckoutIntent();
        if (pendingCheckout) {
          const checkout = await startCheckout(pendingCheckout.productId, pendingCheckout.returnPath);
          if (active) {
            consumePendingBillingCheckoutIntent();
            window.location.replace(checkout.checkoutUrl);
          }
          return;
        }

        window.location.replace("/app");
      } catch (error) {
        if (active) {
          setError(error instanceof Error ? error.message : "better_auth_session_exchange_failed");
        }
      }
    }

    void consumeCallback();
    return () => {
      active = false;
    };
  }, []);

  return (
    <main className="auth-callback-page" aria-live="polite">
      <h1>{error ? "Sign in failed" : "Signing you in"}</h1>
      <p>{error ?? "Redirecting to the Salesko workspace."}</p>
    </main>
  );
}
